import { Button, Checkbox, Container, FormControlLabel, FormGroup, Skeleton, Stack, Typography } from "@mui/material";

import { UUID } from "crypto";
import { useEffect, useState } from "react";

import { useGetReasonUninterestedQuery } from "@services/api/catalogs";
import { usePostLostInterestMutation, usePutApplicationsMutation } from "@services/api/applications";
import { useSelector } from "react-redux";
import { RootState, store } from "@store/store";
import { Permission } from "@interfaces/users";

export interface LoanAppLostInterestProps {
    applicationId: UUID;
    onUpdateRow?: (applicationId: UUID, attr: {}) => void;
}

export const LoanAppLostInterest = (props: LoanAppLostInterestProps) => {
    const [permission, setPermission] = useState<Permission>();
    const [selected, setSelected] = useState<UUID | undefined>(undefined);

    const userSession = useSelector((state: RootState) => state.session.user);
    const permissions = (state = store.getState()) => state.session.permissions;

    const ReasonUninterestedResponse = useGetReasonUninterestedQuery();
    const [triggerSaveLostInterest] = usePostLostInterestMutation();
    const [triggerUpdateApplication] = usePutApplicationsMutation();

    const handleOnClickSave = async () => {
        await triggerSaveLostInterest({
            applicationId: props.applicationId,
            razon_uninterested_id: selected ? selected : "0-0-0-0-0",
        });

        await triggerUpdateApplication({
            applicationId: props.applicationId,
            body: {
                interested: false,
                user_id_modified: userSession.id,
                user_name:
                    userSession.name
                        ?.concat(" ", userSession?.last_name ?? "", " ", userSession?.last_name_2 ?? "")
                        .trim() ?? "",
            },
        });

        props.onUpdateRow?.(props.applicationId, { perdioInteres: 1 });
    };

    useEffect(() => {
        const permissionLocal = permissions(store.getState()).find((t) => t.module.code === "SBCOM");
        setPermission(permissionLocal);
    }, []);

    return (
        <Container maxWidth="xs" sx={{ mb: 3 }}>
            <Stack
                spacing={3}
                sx={{
                    textAlign: "center",
                    alignItems: "center"
                }}>
                <Typography
                    variant="body1"
                    sx={{
                        fontWeight: 500,
                        color: "#002652"
                    }}>
                    Selecciona por que perdió interés
                </Typography>
                <FormGroup>
                    {ReasonUninterestedResponse.isSuccess ? (
                        ReasonUninterestedResponse.data.map((razon, index) => (
                            <FormControlLabel
                                key={index}
                                control={
                                    <Checkbox checked={selected === razon.id} onChange={() => setSelected(razon.id)} />
                                }
                                label={razon.name}
                            />
                        ))
                    ) : (
                        <Skeleton width={"200px"} animation={"wave"}>
                            <FormControlLabel control={<Checkbox />} label="" />
                        </Skeleton>
                    )}
                </FormGroup>
                <Button
                    variant="contained"
                    onClick={handleOnClickSave}
                    disabled={selected === undefined || permission?.can_edit === false}
                >
                    Guardar
                </Button>
            </Stack>
        </Container>
    );
};
